import React, { useEffect, useState } from 'react'
import MyPageTemplate from './components/templates/mypage_template'
import useUser from './hooks/use_user'
import { useSpBreakPoint } from '../../hooks/use_sp_breakpoint'
import UserCard from './components/cards/user_card'
import PagiNationCursor from '../../components/pagination/pagination_cursor'
import LoadingSpinner from '../../components/loading/loading_spinner'
import useFollows from './hooks/use_follows'

const MyPageFollow = () => {
  const PAGE_SIZE = 20

  const isSp = useSpBreakPoint()
  const [user, userLoading] = useUser()
  const [userId, setUserId] = useState('')
  const [follows, size, currentCursor, followLoading, followsHandler] =
    useFollows()
  useEffect(() => {
    if (user) {
      setUserId(user.id)
      followsHandler.load(user?.id)
    }
  }, [user])

  const IndexSectionRef = React.createRef<HTMLDivElement>()
  const scrollToIndexSection = () => {
    if (IndexSectionRef.current) {
      const elementPosition =
        IndexSectionRef.current.getBoundingClientRect().top + window.scrollY
      const offsetPosition = elementPosition - 100
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  const followElems = (
    <>
      <div className="rounded-xl overflow-hidden bg-white">
        {follows?.map((item, index) => {
          return (
            <div key={`follow-${String(index)}`}>
              <UserCard user={item} />
            </div>
          )
        })}
      </div>
      {follows.length === 0 && !followLoading && (
        <div className="text-center py-4 text-gray-400">
          フォローしているユーザーはいません
        </div>
      )}
    </>
  )

  const paginationCursor =
    follows.length > 0 ? (
      <PagiNationCursor
        pageCount={Math.ceil(size / PAGE_SIZE)}
        numRange={3}
        activePageNum={Math.floor(currentCursor / PAGE_SIZE) + 1}
        next={() => {
          scrollToIndexSection()
          followsHandler.load(userId, currentCursor + PAGE_SIZE)
        }}
        prev={() => {
          scrollToIndexSection()
          followsHandler.load(userId, currentCursor - PAGE_SIZE)
        }}
        jump={(pageNum: number) => {
          scrollToIndexSection()
          followsHandler.load(userId, (pageNum - 1) * PAGE_SIZE)
        }}
      />
    ) : null

  const content = (
    <MyPageTemplate
      userLoading={userLoading}
      head="フォローしたユーザー"
      user={user}
      isSp={isSp}
      subHead={userLoading ? '' : `${size.toLocaleString()}ユーザー`}
    >
      <div ref={IndexSectionRef} />
      {followLoading || userLoading ? (
        <LoadingSpinner className="mx-auto" />
      ) : (
        <>
          <div className="pb-8">{followElems}</div>
          <div className="pb-8">{paginationCursor}</div>
        </>
      )}
    </MyPageTemplate>
  )

  return content
}

export default MyPageFollow
